import axios from "axios";
import { getAppSession } from "../utils/appAuth";

// Automatically detect the environment and set the appropriate baseURL
const getBaseURL = () => {
  // If we're in production (hosted on the domain), use the domain's API
  if (window.location.hostname === "abc.brokercore.app") {
    return "https://abc.brokercore.app/api";
  }
  // For development, use localhost (must match backend PORT / package.json proxy)
  return "http://localhost:5001/api";
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 second timeout instead of 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const session = getAppSession();
  if (session?.token) {
    if (config.headers && typeof config.headers.set === "function") {
      config.headers.set("Authorization", `Bearer ${session.token}`);
    } else {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${session.token}`;
    }
  }
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    const headers = config.headers;
    if (headers && typeof headers.delete === "function") {
      headers.delete("Content-Type");
    } else if (headers) {
      delete headers["Content-Type"];
      delete headers["content-type"];
    }
  }
  return config;
});

export default axiosInstance;
